import React from 'react';
import { motion } from 'framer-motion';
import { Section } from './ui/Section';
import { ShieldCheck, RotateCcw } from 'lucide-react';
export function GarantiaSection() {
  return <Section background="secondary" data-id="element-81">
      <motion.div initial={{
      opacity: 0,
      y: 20
    }} whileInView={{
      opacity: 1,
      y: 0
    }} viewport={{
      once: true
    }} className="max-w-3xl mx-auto text-center" data-id="element-82">
        <div className="w-20 h-20 rounded-full bg-navy-900 border-2 border-accent shadow-[0_0_30px_rgba(212,160,220,0.2)] flex items-center justify-center text-accent mx-auto mb-8" data-id="element-83">
          <ShieldCheck size={40} strokeWidth={1.5} data-id="element-84" />
        </div>

        <h2 className="font-serif text-3xl md:text-4xl text-white mb-6" data-id="element-85">
          Garantía total de <span className="text-accent" data-id="element-86">7 días</span>
        </h2>

        <p className="text-lg text-muted mb-8 max-w-2xl mx-auto leading-relaxed" data-id="element-87">
          Comprá con total tranquilidad. Si en los próximos 7 días sentís que el
          manual no te aporta valor, te devolvemos el 100% de tu dinero. Sin
          preguntas, sin vueltas, sin letra chica.
        </p>

        <div className="bg-navy-700 border border-navy-border rounded-xl p-8 inline-block" data-id="element-88">
          <div className="flex items-center gap-4 text-left" data-id="element-89">
            <RotateCcw size={24} className="text-accent flex-shrink-0" data-id="element-90" />
            <div data-id="element-91">
              <p className="text-white font-bold mb-1" data-id="element-92">Riesgo cero para vos</p>
              <p className="text-muted text-sm" data-id="element-93">
                Si no te gusta, si no te sirve, si cambiaste de opinión — te
                devolvemos todo. Así de simple.
              </p>
            </div>
          </div>
        </div>
      </motion.div>
    </Section>;
}